export enum EditorFlow {
  STRICTLY_ENABLED = 'strictly_enabled',
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}
